@if (viewForm && formConfig) {
<div class="form-container">
  <div class="row">
    <ng-container *ngFor="let formItem of formConfig; let i = index">
      <app-form-field [ListLoadChanged]="ListLoadChanged" [files]="files" *ngIf="!formItem.hide"
        [class]="formItem.widthClass ?? 'col-12'" [formGroup]="formGroup" [formItem]="formItem"
        (onLabelClick)="labelClick(formItem , formItem)" [validationErrors]="validationErrors"
        (onAddFormArray)="addFormArray(i)" (onRemoveFormArray)="removeFormArray(i , $event)"
        (onGroupAddFormArray)="addFormArray(i,null,$event)"
        (onGroupRemoveFormArray)="removeFormArray(i , $event['groupIndex'],$event['index'])"
        (onFilterSelect)="onFilterField($event)" (onDownloadFile)="onDownloadFileitem($event)" (onSelected)="onSelectItem($event)"
        (onAddNew)="onAddNewEmitter(formItem)"></app-form-field>
    </ng-container>
    <span *ngIf="formError" class="text-danger mb-2"> {{ formError | translate }}</span>
    <div *ngIf="inlineButton && hasButton" [class]="'d-flex align-items-start justify-content-end '+ buttonWidthClass">
      <button *ngIf=" hasButton " [class]="'btn btn-primary '+buttonWidthClass " (click)="submit() ">{{ buttonText |
        translate
        }}</button>
    </div>
    <div *ngIf="inlineButton && hasResetButton"
      [class]="'d-flex align-items-end mb-3 ' + 'justify-content-'+buttonPos + ' ' + buttonWidthClass">
      <button *ngIf=" hasResetButton " [class]="'btn btn-secondary '+buttonWidthClass " (click)="resetForm() ">{{
        resetButtonText | translate
        }}</button>
    </div>
  </div>
  <div *ngIf="!inlineButton " class="row form-btn " [ngStyle]="{'justify-content': 'end'}"
    [class]="'justify-content-'+buttonPos">
    <button [class]="buttonClass+ ' mx-2 btn btn-outline-secondary'" *ngIf="hasCancelButton"
      (click)="onCancel.emit()">{{'cancel' | translate}}</button>
    <div [class]="buttonClass">
      <button *ngIf="hasButton " class="btn btn-primary btn-full-width w-100" (click)="submit() ">{{ buttonText |
        translate
        }}</button>
      <button *ngIf=" hasResetButton " [class]="'btn btn-secondary mx-2 '+buttonWidthClass " (click)="resetForm() ">{{
        resetButtonText | translate
        }}</button>
    </div>
  </div>
</div>
}
